import { useCallback } from 'react';
import styles from './Filters.module.scss';
import { OrganizationSearchParams } from '../../../api/types/dtos';
import LocationFilterGroup, { LocationSelection } from '../../../components/filter-group/LocationFilterGroup';

interface FiltersProps {
  onChange: (filters: Partial<OrganizationSearchParams>) => void;
  initialValues?: Partial<OrganizationSearchParams>;
}

const Filters = ({ onChange, initialValues }: FiltersProps) => {
  const handleLocationChange = useCallback((selection: LocationSelection) => {
    onChange({
      farmerLocationCountry: selection.country,
      farmerLocationState: selection.state,
      farmerLocationCity: selection.city,
    });
  }, [onChange]);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Filtros</h2>

      <div className={styles.formGroup}>
        <LocationFilterGroup
          initialValues={{
            country: initialValues?.farmerLocationCountry,
            state: initialValues?.farmerLocationState,
            city: initialValues?.farmerLocationCity,
          }}
          onChange={handleLocationChange}
        />
      </div>
    </div>
  );
};

export default Filters; 
